/**
 * @fileoverview Date helper utilities for formatting dates and timestamps
 */

/**
 * Formats a message with a timestamp prefix in the format [YYYY-MM-DD HH:mm]
 * @param {string} message - The message to format
 * @returns {string} Formatted message with timestamp: [YYYY-MM-DD HH:mm] message
 * 
 * @example
 * formatCommentWithTimestamp('Material reservado')
 * // Returns: '[2025-11-07 14:30] Material reservado'
 */
export function formatCommentWithTimestamp(message) {
  const now = new Date();
  
  // Helper to pad numbers with leading zero
  const pad = (n) => n.toString().padStart(2, '0');
  
  // Format date components
  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1); // getMonth() returns 0-11
  const day = pad(now.getDate());
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  
  // Format: [YYYY-MM-DD HH:mm] message
  return `[${year}-${month}-${day} ${hours}:${minutes}] ${message}`;
}

